import React, { useEffect, useRef, useState } from "react";
import soundFxPlayer from "../../services/Audio/SoundFxPlayer";
import translate from "../../services/Translation/lang";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import Sticky from "react-sticky-el";
import AllBetsTab from "../bets-tabs/AllBetsTab";
import PreviousHandTab from "../bets-tabs/PreviousHandTab";
import { filterIsolatedBets } from "../../services/IsolatedBets/isolatedBets";
import rocketmanTransport from "../../services/RocketmanTransport";

export default function AllBetsSubComponent({
  multipliersHistory,
  allBets,
  currRound,
  avatarId,
}) {
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const [lastMultiplier, setLastMultiplier] = useState(
    multipliersHistory.length ? multipliersHistory.slice(-1)[0] : null
  );
  const totalBets =  Object.values(allBets).filter((bet) => bet.round_id === currRound && filterIsolatedBets(bet)).length;

  useEffect(() => {
    if (selectedTabIndex !== 1 && multipliersHistory.length) {
      setLastMultiplier(multipliersHistory.slice(-1)[0]);
    }
  }, [multipliersHistory, selectedTabIndex]);

  return (
    <Tabs
      selectedTabClassName="selected-pod-tab"
      selectedIndex={selectedTabIndex}
      onSelect={(index) => {
        setSelectedTabIndex(index);
        soundFxPlayer.play("slider");
      }}
    >
      <Sticky
        topOffset={-74}
        className={"sticky-header-holder"}
        stickyClassName="sticky-header"
      >
        <header>
          <TabList className={"pod-tabs-nav"}>
            <Tab className={"pod-tabs-nav-item " + (rocketmanTransport.r7css ? "r7css" : "")}>
              {translate("total_bets")}
              <div className={"pod-tabs-nav-badge " + (rocketmanTransport.r7css ? "r7css" : "")}>
                {totalBets}
              </div>
            </Tab>
            <Tab className={"pod-tabs-nav-item " + (rocketmanTransport.r7css ? "r7css" : "")}>
              {translate("previous_hand")}
              <div className={"pod-tabs-nav-badge " + (rocketmanTransport.r7css ? "r7css" : "")}>
                {lastMultiplier ? `${lastMultiplier}x` : ""}
              </div>
            </Tab>
          </TabList>
        </header>
      </Sticky>

      <div className="pod-tabs-panel-holder container">
        <TabPanel>
          <AllBetsTab
            bets={Object.values(allBets).filter(
              (bet) => bet.round_id === currRound
            )}
            avatarId={avatarId}
          />
          
        </TabPanel>
        <TabPanel>
          <PreviousHandTab
            bets={Object.values(allBets).filter(
              (bet) => bet.round_id === currRound - 1
            )}
            avatarId={avatarId}
          />
        </TabPanel>
      </div>
    </Tabs>
  );
}
